import { Component, OnInit, inject } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog'
import { IconsModule } from '@ziptility/icons'

export interface FeatureIdentifiersData {
  systemId: string
  locationIdentifier: string
}

@Component({
  selector: 'feature-identifier',
  template: `
    <div class="mb-2 border-b border-gray-200 p-5 font-semibold flex flex-row justify-between grid grid-cols-12">
      <div class="col-span-2 flex justify-center items-center cursor-pointer" (click)="dialogRef.close(false)">
        <i-feather name="x"></i-feather>
      </div>
      <div class="col-span-8 text-center">Rename</div>
      <div class="col-span-2"></div>
    </div>
    <div mat-dialog-content>
      @if (form) {
        <form [formGroup]="form" class="flex flex-col mt-2 w-[360px]" (ngSubmit)="dialogRef.close(form.value)">
          <input
            class="
              px-4
              py-2
              focus:outline-none
              hover:outline-none
              rounded-lg
              border border-gray-200
              w-full
              mb-2
            "
            type="text"
            formControlName="systemId"
            placeholder="Identifier"
          />

          @if (form.get('systemId')?.errors?.maxlength; as maxLengthError) {
            <div class="text-sm px-3 mb-2">
              Cannot be longer than 32 characters (currently {{ maxLengthError.actualLength }})
            </div>
          }

          <input
            class="
          px-4
          py-2
          focus:outline-none
          hover:outline-none
          rounded-lg
          border border-gray-200
          w-full
        "
            formControlName="locationIdentifier"
            type="text"
            placeholder="Location nickname"
          />
          <div class="flex items-stretch justify-center mt-3">
            <button
              type="button"
              class="bg-white px-3 py-2 text-red-brand rounded-md text-center text-xs border border-gray-200 mr-2 flex-grow font-semibold"
              (click)="dialogRef.close(false)"
            >
              Cancel
            </button>
            <button
              class="bv-button bv-submit-button block flex-grow"
              type="submit"
              [disabled]="!form.valid || !form.dirty"
            >
              Save
            </button>
          </div>
        </form>
      }
    </div>
  `,
  imports: [ReactiveFormsModule, IconsModule, MatDialogContent],
})
export class FeatureIdentifiersComponent implements OnInit {
  readonly fb = inject(FormBuilder)
  readonly dialogRef = inject(MatDialogRef<FeatureIdentifiersComponent>)
  readonly data: FeatureIdentifiersData = inject(MAT_DIALOG_DATA)

  form: FormGroup

  ngOnInit() {
    this.form = this.fb.group({
      systemId: [this.data.systemId ?? '', [Validators.required, Validators.maxLength(32)]],
      locationIdentifier: [this.data.locationIdentifier ?? ''],
    })
  }
}
